import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { State } from './types';
import { baseQuery, endpoints } from 'utils/api/endpoints';

export const initialState: State = {};

const slice = createSlice({
  name: 'paymentMethods',
  initialState,
  reducers: {},
});

export const api = createApi({
  reducerPath: 'paymentMethodsApi',
  baseQuery,
  tagTypes: ['PaymentMethods'],
  endpoints: builder => ({
    getPaymentMethods: builder.query<any, any>({
      query: (params: any = {}) => {
        return {
          url: endpoints.PAYMENT_GATEWAYS + '/all',
          method: 'GET',
          params,
        };
      },
    }),
    updatePaymentMethod: builder.mutation<any, any>({
      query: (params: any = {}) => {
        return {
          url: endpoints.PAYMENT_GATEWAYS + '/update',
          method: 'PATCH',
          body: params,
        };
      },
      invalidatesTags: ['PaymentMethods'],
    }),
    setDefaultPaymentMethod: builder.mutation<any, any>({
      query: (params: any = {}) => {
        return {
          url: endpoints.PAYMENT_GATEWAYS + '/set-default',
          method: 'PATCH',
          body: params,
        };
      },
      invalidatesTags: ['PaymentMethods'],
    }),
    changePaymentMethodOrder: builder.mutation<any, any>({
      query: (params: any = {}) => {
        return {
          url: endpoints.PAYMENT_GATEWAYS + '/change-order',
          method: 'PATCH',
          body: params,
        };
      },
      invalidatesTags: ['PaymentMethods'],
    }),
    getActivePaymentMethods: builder.query<any, void>({
      query: () => {
        return {
          url: endpoints.PAYMENT_GATEWAYS + '/all?status=1',
          method: 'GET',
        };
      },
    }),
  }),
});

export const { actions: paymentMethodsActions } = slice;

export const usePaymentMethodsSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    actions: slice.actions,
    useGetPaymentMethodsQuery: api.useLazyGetPaymentMethodsQuery,
    useImmediateGetPaymentMethodsQuery: api.useGetPaymentMethodsQuery,
    useUpdatePaymentMethodMutation: api.useUpdatePaymentMethodMutation,
    useSetDefaultPaymentMethodMutation: api.useSetDefaultPaymentMethodMutation,
    useChangePaymentMethodOrderMutation:
      api.useChangePaymentMethodOrderMutation,
    useGetActivePaymentMethodsQuery: api.useLazyGetActivePaymentMethodsQuery,
  };
};
